import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import Text from '~components/atoms/Text';

import PaperGoldPricingTable from './PaperGoldPricingTable';
import PhysicalGoldPricingTable from './PhysicalGoldPricingTable';
import * as Styles from './_dailyGoldPrice.module.scss';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import PreciousMetalPricingTable from './PreciousMetalPricingTable';

const DailyGoldPrice = () => {
    const dispatch = useAppDispatch();
    const goldPrices = useAppSelector((state) => state.gold.buyAndSellGold.goldPrices);

    const [gbuyPrice, setGbuyPrice] = useState<string>('');
    const [gsellPrice, setGsellPrice] = useState<string>('');

    useEffect(() => {
        // Initial dispatch
        dispatch(combinedActions.goldGetGoldPricesAttempt());
        dispatch(combinedActions.dashboardGetDashboardProductPricingAttempt());

        // Set up interval to dispatch every 3 seconds
        const intervalId = setInterval(() => {
            dispatch(combinedActions.goldGetGoldPricesAttempt());
            dispatch(combinedActions.dashboardGetDashboardProductPricingAttempt());
        }, 3000); // 3000 milliseconds = 3 seconds

        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        setGbuyPrice(goldPrices.gbuy);
        setGsellPrice(goldPrices.gsell);
    }, [goldPrices]);

    return (
        <div className={Styles.container}>
            <div className={Styles['info-container']}>
                <Text
                    label='DAILY GOLD PRICE'
                    className={Styles.title}
                    isBold
                />
                <Text
                    label={`API Gold Buy Price: ${gbuyPrice} | API Gold Sell Price: ${gsellPrice}`}
                    className={Styles['gold-price-text']}
                />
                <Text
                    label={`Updated at ${dayjs(goldPrices.validFrom).format('DD MMM YYYY HH:mm:ss A')}`}
                />
            </div>

            <div className={Styles['price-container']}>
                <PhysicalGoldPricingTable />

                <div className={Styles['block-container']}>
                    <PaperGoldPricingTable />

                    <PreciousMetalPricingTable />
                </div>
            </div>
            <div className={Styles['info-container']}>
                <Text
                    label={'*The above denominations are subject to the Bank\'s discretion from time to time.'}
                />
            </div>
        </div>
    );
};

export default DailyGoldPrice;
